import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '@config/store';
import { authInfoSelect } from '@entities/auth';
import { clientSelect } from '@entities/client';
import {
    getAllCardsSpendStats,
    getClientCardChanges,
    getClientCards,
    getClientCardTransactions,
} from '@api/thunks/card';
import { IPaginatedProps } from '@types';
import { getClientsFavoriteProducts } from '@api/thunks/clients';

export const useClientData = (
    transPagination: IPaginatedProps,
    changesPagination: IPaginatedProps
) => {
    const dispatch = useDispatch<AppDispatch>();
    const { shop } = useSelector(authInfoSelect);
    const { selectedClient } = useSelector(clientSelect);

    useEffect(() => {
        if (shop && selectedClient) {
            const data = { client_id: selectedClient.id, shop_id: shop.id };

            const { limit, page } = transPagination;
            const query = { limit, offset: (page - 1) * limit };
            dispatch(getClientCardTransactions({ ...data, query }));
            dispatch(
                getClientsFavoriteProducts({
                    shop_id: shop.id,
                    client_id: selectedClient.id,
                })
            );
        }
    }, [shop, selectedClient, dispatch, transPagination]);

    useEffect(() => {
        if (shop && selectedClient) {
            const data = { client_id: selectedClient.id, shop_id: shop.id };
            const { limit, page } = changesPagination;
            const query = { limit, offset: (page - 1) * limit };
            dispatch(getClientCardChanges({ ...data, query }));
        }
    }, [shop, selectedClient, dispatch, changesPagination]);

    useEffect(() => {
        if (shop && selectedClient) {
            const data = { client_id: selectedClient.id, shop_id: shop.id };
            dispatch(getClientCards(data));
        }
    }, [shop, selectedClient, dispatch]);

    useEffect(() => {
        if (shop && selectedClient) {
            dispatch(
                getAllCardsSpendStats({
                    shop_id: shop.id,
                    client_id: selectedClient.id,
                })
            );
        }
    }, [shop, selectedClient, dispatch]);
};
